export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-white text-lg"></i>
              </div>
              <span className="font-heading text-xl text-white">每日吃瓜</span>
            </div>
            <p className="text-sm text-white/55 leading-relaxed mb-4">
              每日吃瓜是领先的明星大瓜视频聚合平台，每日更新最新吃瓜现场实录、明星爆瓜视频及热门大瓜推荐，高清在线观看不卡顿，一站式追更吃瓜视频合集。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-white text-sm"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-white text-sm"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-white text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-white mb-4">快速导航</h4>
            <div className="space-y-2.5">
              <a href="#carousel" className="block text-sm text-white/55 hover:text-primary-400 transition-colors cursor-pointer">焦点专题</a>
              <a href="#ranking" className="block text-sm text-white/55 hover:text-primary-400 transition-colors cursor-pointer">热度榜单</a>
              <a href="#cards" className="block text-sm text-white/55 hover:text-primary-400 transition-colors cursor-pointer">爆瓜精选</a>
              <a href="#media" className="block text-sm text-white/55 hover:text-primary-400 transition-colors cursor-pointer">现场直击</a>
              <a href="#index" className="block text-sm text-white/55 hover:text-primary-400 transition-colors cursor-pointer">瓜圈索引</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-white mb-4">吃瓜分类</h4>
            <div className="space-y-2.5">
              <a href="#index" className="block text-sm text-white/55 hover:text-primary-400 transition-colors cursor-pointer">明星八卦</a>
              <a href="#index" className="block text-sm text-white/55 hover:text-primary-400 transition-colors cursor-pointer">综艺爆料</a>
              <a href="#index" className="block text-sm text-white/55 hover:text-primary-400 transition-colors cursor-pointer">恋情曝光</a>
              <a href="#index" className="block text-sm text-white/55 hover:text-primary-400 transition-colors cursor-pointer">影视圈动态</a>
              <a href="#index" className="block text-sm text-white/55 hover:text-primary-400 transition-colors cursor-pointer">网红圈热点</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-white/40 leading-relaxed">
              诚邀各大娱乐媒体、视频平台及内容创作者加入合作，共同打造最优质的吃瓜视频生态。
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">
            &copy; 2026 每日吃瓜 meirichigua.com . All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-white/40 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#hero" className="text-xs text-white/40 hover:text-primary-400 transition-colors cursor-pointer">用户协议</a>
            <a href="#contact" className="text-xs text-white/40 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}